(() => {
  if (customElements.get('menasa-artistic-scroll')) return;
  class ArtisticScroll extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const host = this, controller = new AbortController(), frames = new Set(), observers = [];
      const on = (target, type, callback, options = {}) => target.addEventListener(type, callback, {...(typeof options === 'boolean' ? {capture: options} : options), signal:controller.signal});
      const touchViewport=window.matchMedia('(pointer: coarse)').matches;
      const probe=window.document.createElement('div');
      probe.style.cssText='display:block;position:absolute;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
      probe.setAttribute('aria-hidden','true');host.append(probe);
      let viewportWidth=window.innerWidth,sceneHeight=window.innerHeight;
      const sizeViewport=()=>{
        sceneHeight=touchViewport?(probe.offsetHeight||window.innerHeight):window.innerHeight;
        if(touchViewport)host.style.setProperty('--menasa-scene-vh',`${sceneHeight/100}px`);
      };
      sizeViewport();
      // Android toolbar/keyboard changes height during scroll. Only a width
      // change (rotation, split-screen, editor) should rebuild the scene layout.
      on(window,'resize',()=>{if(!touchViewport||window.innerWidth!==viewportWidth){viewportWidth=window.innerWidth;sizeViewport()}},{passive:true});
      const addEventListener = (type, callback, options) => {
        let width=window.innerWidth;
        on(window,type,type==='resize'&&touchViewport?event=>{if(width===window.innerWidth)return;width=window.innerWidth;callback(event)}:callback,options);
      };
      // All scene controllers share one read phase per browser frame. Never force
      // layout between their writes. Geometry stays local to this section instance.
      const geometry=new Map();let measuredAt=-1;
      const sceneRenderers=[];
      let innerWidth=window.innerWidth,innerHeight=sceneHeight,scrollY=window.scrollY;
      const geometryNodes=[...host.querySelectorAll('.hero,.drop,.hero__copy > *,#study,.journey,.stage,.stay,.drop__film-edge,.closing-curve,.pattern-field,.film-panel'),window.document.querySelector('#PrestigeHeader')].filter(Boolean);
      const captureGeometry=time=>{if(time===measuredAt)return;measuredAt=time;innerWidth=window.innerWidth;innerHeight=sceneHeight;
        const scroller=window.document.scrollingElement;
        scrollY=Math.max(0,Math.min(window.scrollY,Math.max(0,scroller.scrollHeight-scroller.clientHeight)));
        const bounce=window.scrollY-scrollY;
        for(const node of geometryNodes){
        // Reading descendants of a skipped subtree would force its layout again.
        if(node.parentElement?.closest('[data-occluded],.hero[data-offscreen]'))continue;
        const r=node.getBoundingClientRect();
        const rect=bounce?{x:r.x,y:r.y+bounce,top:r.top+bounce,bottom:r.bottom+bounce,left:r.left,right:r.right,width:r.width,height:r.height}:r;
        geometry.set(node,{rect,height:node.offsetHeight,top:node.offsetTop});
      }};
      const readRect=node=>geometry.get(node)?.rect || node.getBoundingClientRect();
      const readSize=node=>geometry.get(node) || {height:node.offsetHeight,top:node.offsetTop};
      const values=new WeakMap();
      const setProperty=(node,name,value)=>{let previous=values.get(node);if(!previous){previous=new Map();values.set(node,previous)}value=String(value);if(previous.get(name)===value)return;previous.set(name,value);node.style.setProperty(name,value)};
      const largeSurfaces=new Set(host.querySelectorAll('.film-panel,.garment,.material,.foreground'));
      const setStyle=(node,name,value)=>{
        if((name==='filter'||name==='textShadow')&&['light','reduced'].includes(window.MenasaQuality?.tier))value='none';
        if(name==='filter'&&largeSurfaces.has(node)&&window.MenasaQuality?.tier!=='full')return;
        let previous=values.get(node);if(!previous){previous=new Map();values.set(node,previous)}
        value=String(value);if(previous.get(name)===value)return;previous.set(name,value);node.style[name]=value;
      };
      const requestAnimationFrame = callback => {
        if(controller.signal.aborted) return 0;
        const id=window.requestAnimationFrame(time=>{frames.delete(id);if(!controller.signal.aborted){captureGeometry(time);callback(time)}});
        frames.add(id);return id;
      };
      const cancelAnimationFrame = id => {window.cancelAnimationFrame(id);frames.delete(id)};
      const matchMedia = query => {
        const mq=window.matchMedia(query);
        return {get matches(){return mq.matches},addEventListener:(type,callback,options)=>on(mq,type,callback,options)};
      };
      const document = {
        querySelector:selector=>selector==='main'?host:selector==='.site-header'?window.document.querySelector('#PrestigeHeader'):host.querySelector(selector), querySelectorAll:selector=>host.querySelectorAll(selector),
        getElementById:id=>host.querySelector('#'+id),
        createElement:name=>window.document.createElement(name), fonts:window.document.fonts,
        get hidden(){return window.document.hidden},
        body:{hasAttribute:name=>name==='data-full-page'}, addEventListener:(...args)=>on(window.document,...args),
      };
      const IntersectionObserver = class extends window.IntersectionObserver {constructor(...args){super(...args);observers.push(this)}};
      const ResizeObserver = class extends window.ResizeObserver {constructor(...args){super(...args);observers.push(this)}};
      this.refreshScene=()=>{const time=performance.now();measuredAt=-1;captureGeometry(time);sceneRenderers.forEach(render=>render(time))};
      this.cleanup=()=>{controller.abort();frames.forEach(window.cancelAnimationFrame);observers.forEach(o=>o.disconnect());host.querySelector('video')?.pause();probe.remove();host.style.removeProperty('--menasa-scene-vh');this.refreshScene=null;this.cleanup=null};
      // Restore generated nodes when the editor reconnects the same element.
      ['court','right','near','model'].forEach(name=>host.querySelector('#hero-chroma-'+name)?.remove());
      (() => {
  const hero = document.querySelector('.hero');
  const model = hero.querySelector('.hero__model-wrap'), copy = hero.querySelector('.hero__copy');
  const cue = hero.querySelector('.hero__cue');
  const drop = document.querySelector('.drop');
  const layers = [...document.querySelectorAll('[data-depth]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const copyParts = [...document.querySelector('.hero__copy').children];
  const header = document.querySelector('.site-header');
  // Each image needs its own blend: a shared SVG filter gives every plane the
  // same color separation even when their blur amounts differ.
  const chromaTemplate = document.querySelector('#hero-chroma-sky');
  const chromaMixes = {sky: chromaTemplate.querySelector('feComposite')};
  for (const name of ['court', 'right', 'near', 'model']) {
    const filter = chromaTemplate.cloneNode(true);
    filter.id = `hero-chroma-${name}`;
    chromaTemplate.parentNode.append(filter);
    chromaMixes[name] = filter.querySelector('feComposite');
  }
  // Overlapping feather masks keep the blur gradient free of hard slice edges.

  let entranceStart = null;
  Promise.allSettled([...hero.querySelectorAll('img')].map(img => img.decode())).then(async () => {
    await (window.menasaIntroReady || Promise.resolve());
    hero.classList.add('is-ready');
    // No entrance after a page transition, or when the landing page has already been seen this session.
    const rootClass = window.document.documentElement.classList;
    entranceStart = rootClass.contains('menasa-route-ready') || rootClass.contains('menasa-home-seen') ? null : performance.now();
    schedule();
  });
  const clamp = v => Math.min(1, Math.max(0, v));
  const smooth = v => { const t = clamp(v); return t * t * (3 - 2 * t); };
  let frame = 0;
  let previousTime = 0;
  let focus = 0;
  let headerProgress = 0;
  const copyProgress = copyParts.map(() => 0);
  function update(time) {
    frame = 0;
    // First Drop has an opaque rectangular body below its curved leading edge.
    // Wait until that body covers the viewport, then stop the hidden hero work.
    const offscreen=readRect(drop).top<=-2 || readRect(hero).bottom<=0;
    hero.toggleAttribute('data-offscreen',offscreen);
    if(offscreen){previousTime=0;return}
    // Ease the effects, not native scrolling. Continue until the values settle,
    // including after a wheel notch or an immediate jump in either direction.
    const elapsed = previousTime ? Math.min(32, time - previousTime) : 16.67;
    previousTime = time;
    const blend = 1 - Math.exp(-elapsed / 100);
    let unsettled = false;
    const follow = (current, target) => {
      if (reduced.matches || Math.abs(target - current) < .0001) return target;
      unsettled = true;
      return current + (target - current) * blend;
    };
    const h = innerHeight;
    // Phones render no scene filters (menasa-experience.css), so they skip the blur work
    // too: a blur value on .hero restyles the whole hero every frame for nothing.
    const light=['light','reduced'].includes(window.MenasaQuality?.tier) || !!window.MenasaQuality?.phone || (!!window.MenasaQuality?.vaultLite && hero.classList.contains('hero--photo')) || !!window.MenasaQuality?.noBlur;
    const dropTop = readRect(drop).top;
    const p = reduced.matches ? 0 : clamp(scrollY / h);
    focus = light ? 0 : follow(focus, reduced.matches ? 0 : smooth((h - dropTop) / (h * .87)));
    const dividerTop = dropTop - h * .045;
    // Both ends reach ivory when First Drop covers the full header (top <= 0).
    if (!document.body.hasAttribute('data-full-page')) {
      headerProgress = follow(headerProgress, smooth((h * .9 - dropTop) / (h * .9)));
      setProperty(header,'--header-top', `${.5 + headerProgress * .5}`);
      setProperty(header,'--header-bottom', `${headerProgress ** 4}`);
    }
    copyParts.forEach((part, index) => {
      if(light)return;
      if(light)return;
      const bottom = readRect(part).bottom;
      const target = reduced.matches ? 0 : smooth((bottom + h * .34 - dividerTop) / (h * .46));
      const proximity = copyProgress[index] = follow(copyProgress[index], target);
      const copyBlur = proximity * 5;
      setProperty(part,'--copy-blur', `${copyBlur}px`);
      setProperty(part,'--copy-fringe', `${copyBlur / 5}px`);
      setProperty(part,'--fringe-alpha', `${copyBlur / 5 * .52}`);
    });
    // Written as transforms, not the --x/--y/--s variables the CSS also accepts: a changed
    // inherited variable restyles every child of the plane, every frame.
    layers.forEach(layer => {
      const d = Number(layer.dataset.depth);
      const direction = layer.classList.contains('scene-near') ? -1 : layer.classList.contains('scene-right') ? 1 : 0;
      setStyle(layer,'transform',`translate3d(${direction * p * d * innerWidth * .09}px,${-p * d * h * .13}px,0) scale(${1 + p * d * .13})`);
    });
    setStyle(model,'transform',`translate3d(${p * innerWidth * .008}px,${-p * h * .035}px,0) scale(${1 + p * .035})`);
    // "Scroll to explore" has done its job once the visitor scrolls: it fades over the
    // first sixth of a screen and stops painting (its loop pauses with it).
    if(cue){const shown=reduced.matches?1:1-smooth(p*6);setStyle(cue,'opacity',shown.toFixed(3));setStyle(cue,'visibility',shown>0?'visible':'hidden')}
    setProperty(copy,'--text-y', `${-p * 22}px`);
    // The entrance defocus uses the same values as the scroll effect, so its
    // chromatic blend never gets ahead of or lags behind the visible blur.
    const entrance = light || entranceStart === null || reduced.matches ? 0 : 1 - smooth((time - entranceStart) / 1100);
    if (entrance > 0) unsettled = true;
    const blur = {
      sky: .7 + focus * 7,
      court: focus * 6.1 + entrance * 5,
      right: .2 + focus * 5.2,
      near: (innerWidth < 800 ? 2.5 : 4) + focus * 8,
      model: focus * 3.2 + entrance * 3,
    };
    const blurProperties = {sky:'--sky-blur', court:'--distant-blur', right:'--right-blur', near:'--near-blur', model:'--model-blur'};
    for (const [name, amount] of Object.entries(blur)) {
      if(light)continue;
      setProperty(hero,blurProperties[name], `${amount * (window.MenasaQuality?.intensity ?? 1)}px`);
      // feOffset rasterizes in steps. Blend fixed +/-0.9px channels by the
      // actual blur in pixels, retaining the existing .8 maximum.
      const strength = reduced.matches || (window.MenasaQuality?.tier || 'full') !== 'full' ? 0 : Math.min(.8, amount * .1);
      if(chromaMixes[name].getAttribute('k2')!==strength.toFixed(5)){chromaMixes[name].setAttribute('k2', strength.toFixed(5));chromaMixes[name].setAttribute('k3', (1-strength).toFixed(5))}
    }
    if (unsettled) frame = requestAnimationFrame(update);
    else previousTime = 0;
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  reduced.addEventListener('change', schedule);
  sceneRenderers.push(time=>{cancelAnimationFrame(frame);update(time)});
  schedule();
})();

(() => {
  const root = document.getElementById('study');
  const act = root.querySelector('.journey');
  const flowingClose = root.hasAttribute('data-closing-flow');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const get = selector => root.querySelector(selector);
  const video = get('.film'), film = get('.film-panel'), vault = get('.vault');
  const stage=get('.stage');
  const filmEdge=document.querySelector('.drop__film-edge');
  const title = get('.vault-title'), falcon = get('.garment--falcon'), mosaic = get('.garment--mosaic');
  const fPhoto = get('.material--falcon'), mPhoto = get('.material--mosaic');
  const fFront = get('.foreground--falcon'), mFront = get('.foreground--mosaic');
  const fCopy = get('.garment-copy--falcon'), mCopy = get('.garment-copy--mosaic');
  const stay = get('.stay'), stayInner = get('.stay-inner'), header = get('.site-header');
  const toggle = get('.film-toggle'), filmLabel = get('.film-label');
  const clamp = value => Math.max(0, Math.min(1, value));
  const ease = (start, end, progress) => {
    const t = clamp((progress - start) / (end - start));
    return t * t * (3 - 2 * t);
  };
  const fringe = name => document.querySelector('[data-fringe="'+name+'"]');
  const fRed=fringe('falcon-red'),fBlue=fringe('falcon-blue'),mRed=fringe('mosaic-red'),mBlue=fringe('mosaic-blue');
  let last = -1, userPaused = false, frameId = 0;
  let lastReduced = reduce.matches;
  let filmVisible = false, playPending = false, userPlayed = false;
  let sourceReady=!video.hasAttribute('data-mobile-src');
  const preparedScenes=new WeakSet();
  function prepareScene(scene){
    if(preparedScenes.has(scene))return;
    preparedScenes.add(scene);
    for(const image of scene.querySelectorAll('img')){image.decoding='async';image.loading='eager';image.decode().catch(()=>{})}
  }
  function loadFilm(){
    if(sourceReady)return;
    sourceReady=true;
    const mobile=matchMedia('(max-width: 849px)').matches || window.MenasaQuality?.tier==='light';
    video.preload='auto';
    video.src=window.MenasaQuality?.tier==='light' && video.dataset.lightSrc ? video.dataset.lightSrc : mobile?video.dataset.mobileSrc:video.dataset.desktopSrc;
    video.load();
  }
  function shouldPlayFilm(){
    // Play as soon as any part of the film shows below First Drop's curved edge.
    const uncovered=reduce.matches||!filmEdge||readRect(filmEdge).bottom<innerHeight-1;
    return !document.hidden && filmVisible && !film.hasAttribute('data-occluded') && !userPaused && (reduce.matches ? userPlayed : uncovered && last < .30);
  }
  function syncPlayback() {
    const shouldPlay = shouldPlayFilm();
    if (!shouldPlay) video.pause();
    else if (video.paused && !playPending) {
      loadFilm();
      playPending = true;
      video.play().catch(()=>{}).finally(()=>{ playPending = false;if(!shouldPlayFilm())video.pause(); });
    }
  }
  const filmObserver = new IntersectionObserver(entries => {
    filmVisible = entries[0].isIntersecting;
    syncPlayback();
  }, {threshold:0});
  filmObserver.observe(film);
  const preloadObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){loadFilm();preloadObserver.disconnect()}},{rootMargin:'600px'});
  preloadObserver.observe(act);
  // Falcon and Mosaic decode well before the film: a fast fling otherwise reached them
  // while their images were still arriving, and they appeared out of nowhere.
  const sceneObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){prepareScene(falcon);prepareScene(mosaic);sceneObserver.disconnect()}},{rootMargin:'0px 0px 250% 0px'});
  sceneObserver.observe(act);
  // Phones fetch the film once the page is idle and show a decoded first frame before
  // the Vault uncovers it, so the poster never appears. Save-Data keeps the lazy path.
  const phoneFilm=matchMedia('(max-width: 849px)').matches || window.MenasaQuality?.tier==='light';
  // On phones the Vault title rides just above the rising edge, in the dark part of its
  // gradient, then waits under the header while Falcon rises over it.
  const phoneLayout=matchMedia('(max-width: 849px)');
  const TITLE_LEAD=142;
  let framePrimed=false;
  function primeFilm(){
    if(framePrimed||reduce.matches||!video.paused||playPending||shouldPlayFilm())return;
    framePrimed=true;
    let settled=false;
    const shown=()=>{
      if(settled)return;
      settled=true;
      if(!shouldPlayFilm())video.pause();
      // A muted play then pause leaves a real frame on screen (iOS needs this).
      if(video.readyState>=2)video.removeAttribute('poster');
    };
    video.play().then(()=>{
      video.requestVideoFrameCallback?.(shown);
      on(video,'timeupdate',shown,{once:true});
      setTimeout(shown,1500);
    }).catch(()=>{framePrimed=false});
  }
  if(phoneFilm&&!navigator.connection?.saveData){
    const early=()=>(window.requestIdleCallback||(fn=>setTimeout(fn,300)))(()=>{loadFilm();if(video.readyState>=3)primeFilm()},{timeout:2500});
    on(video,'canplay',primeFilm);
    if(window.document.readyState==='complete')early();else addEventListener('load',early,{once:true});
  }
  document.addEventListener('visibilitychange',syncPlayback);
  on(video,'canplay',syncPlayback);
  const scheduleFilm = () => { if (!frameId) frameId=requestAnimationFrame(render); };
  addEventListener('scroll',scheduleFilm,{passive:true});
  addEventListener('resize',scheduleFilm,{passive:true});

  // The pinned scene follows the scroll with a short glide instead of jumping to it. A fast
  // wheel or a fling used to skip whole stages in one frame, so Falcon, Mosaic and their
  // words appeared abruptly. Time-based (frame-rate independent); the stage itself is
  // native sticky, so nothing slips against the page. Fine pointers glide a little longer.
  const GLIDE=touchViewport?90:120;
  let shown=-1, shownAt=0, snap=true;
  function render(time=performance.now()) {
    frameId = 0;
    // Some Chromium media-emulation changes update matches before dispatching
    // this query's event. Keep focusability and playback in step with CSS.
    if (lastReduced !== reduce.matches) motionChange();
    if (reduce.matches) return;
    const raw = clamp(-readRect(act).top / Math.max(1, readSize(act).height - innerHeight));
    const stageBounds=readRect(stage);
    const outside=stageBounds.bottom<=-80 || stageBounds.top>=innerHeight+80;
    const dt=shownAt?Math.min(64,time-shownAt):16.67;
    shownAt=time;
    if(snap || shown<0 || outside)shown=raw;
    else{shown+=(raw-shown)*(1-Math.exp(-dt/GLIDE));if(Math.abs(raw-shown)<.0004)shown=raw}
    snap=false;
    const p=shown;
    if(p!==raw)scheduleFilm();else shownAt=0;
    // A layer is needed where either the scroll or the gliding scene still shows it.
    const lo=Math.min(p,raw), hi=Math.max(p,raw);
    act.menasaProgress=p;
    // Culling keeps fixed scene dimensions, so sticky layout and reverse scroll
    // remain stable. Never cull behind a partially transparent curved edge.
    // Mosaic is ready (painted, below the screen) well before it rises at .49.
    film.toggleAttribute('data-occluded',outside || lo>=.30);
    if(outside || lo>=.30)video.pause();
    falcon.toggleAttribute('data-occluded',outside || lo>=.80);
    mosaic.toggleAttribute('data-occluded',outside || hi<=.40);
    syncPlayback();
    if (Math.abs(p - last) < .00001) return;
    last = p;
    if(hi>.25)prepareScene(mosaic);
    const full=(window.MenasaQuality?.tier || 'full')==='full';
    const lite=!!window.MenasaQuality?.vaultLite || !!window.MenasaQuality?.noBlur;
    // Covered scenes need neither paint surfaces nor video decoding. These ranges
    // overlap the curved edges so reverse scrolling reveals fully prepared content.
    setStyle(film,'visibility',lo<.30?'visible':'hidden');
    setStyle(falcon,'visibility',lo<.80?'visible':'hidden');
    setStyle(mosaic,'visibility',hi>.40?'visible':'hidden');
    const enter = ease(.08,.30,p), fReveal = ease(.25,.43,p);
    const next = ease(.49,.72,p), focus = ease(.53,.72,p);
    // The closing surface is placed against the real page, so it follows the scroll itself.
    const close = ease(.79,.965,raw), settle = ease(.795,.865,raw);
    const fDetail=ease(.28,.43,p),mDetail=ease(.58,.73,p);
    // The title blurs and dims as Falcon comes in, as Falcon later does for Mosaic.
    const fCover=ease(.26,.38,p);
    const fText=ease(.265,.415,p),mText=ease(.555,.705,p);
    // Use the same viewport unit and progress for each depth plane: 8 / 16 / 24.
    const fTravel=ease(.34,.72,p),mTravel=ease(.65,.96,p);
    setStyle(vault,'transform','translate3d(0,' + (125*(1-enter)) + '%,0)');
    // A stable video plane can use the hardware decoder/compositor directly.
    // The Vault still covers it with the same curved entrance.
    setStyle(film,'transform',full ? 'scale(' + (1+.06*enter) + ')' : 'none');
    setStyle(film,'filter','blur(' + (enter*7) + 'px)');
    setStyle(filmLabel,'opacity',String(1-ease(.03,.12,p)));
    const vaultShift=1.25*(1-enter)*readSize(vault).height;
    const titleLead=phoneLayout.matches?Math.min(vaultShift,TITLE_LEAD):0;
    setStyle(title,'transform','translate3d(0,' + (28*(1-fReveal)-next*85-titleLead) + 'px,0)');
    setStyle(title,'opacity',String(1-ease(.34,.43,p)));
    // The title comes into focus as it rises to the middle of the screen and stays sharp
    // above it until the scene fades it out.
    const titleCentre=stageBounds.top+vaultShift+readSize(title).top+28*(1-fReveal)-next*85-titleLead+readSize(title).height/2;
    const titleSharp=1-ease(0,.6,(titleCentre-innerHeight/2)/(innerHeight/2));
    setStyle(title,'filter','blur('+((1-titleSharp)*14+fCover*10+focus*7)+'px) brightness('+(1-fCover*.3)+')');
    const titleFringe=(1-titleSharp)*1.5+focus;
    setStyle(title,'textShadow',titleFringe+'px 0 #e270713d,'+(-titleFringe)+'px 0 #75bace3d');
    setStyle(falcon,'transform',full?'translate3d(0,' + (-next*7) + '%,0) scale(' + (1-next*.055) + ')':'none');
    setStyle(falcon,'filter','blur(' + (focus*11) + 'px) brightness(' + (1-focus*.28) + ')');
    // Mosaic's top edge is transparent, so Falcon showed through it until being hidden
    // at .77. Fade it out first so it never disappears in a single frame.
    setStyle(falcon,'opacity',String(1-ease(.64,.76,p)));
    setStyle(fPhoto,'transform','translate3d(0,' + ((10*(1-fReveal)-fTravel*8)*innerHeight/100) + 'px,0) scale(1.04)');
    // On the phone path there is no full-scene defocus to soften the outgoing
    // label. Fade it before Mosaic settles so it cannot show through its top mask.
    setStyle(fCopy,'opacity',String(fText*(full?1:1-ease(.60,.72,p))));
    setStyle(fCopy,'transform','translate3d(0,' + ((8*(1-fText)-fTravel*24)*innerHeight/100) + 'px,0)');
    setStyle(fCopy,'filter','blur('+((1-fText)*7)+'px)');
    setStyle(fFront,'opacity','1');
    setStyle(fFront,'transform','translate3d(0,' + ((14*(1-fDetail)-fTravel*16)*innerHeight/100) + 'px,0) rotate(16deg) scale(1.08)');
    setStyle(fFront,'filter','blur('+((1-fDetail)*10)+'px)');setStyle(fPhoto,'filter','blur('+((1-fReveal)*8)+'px)');
    if(full&&!lite){fRed.setAttribute('dx',String(focus*1.8));fBlue.setAttribute('dx',String(-focus*1.8))}
    setStyle(mosaic,'transform','translate3d(0,' + (125*(1-next)-(full?close*5:0)) + '%,0) scale(' + (full?1-close*.045:1) + ')');
    setStyle(mosaic,'filter','blur(' + ((1-focus)*9+close*10) + 'px)');
    setStyle(mPhoto,'transform','translate3d(0,' + ((10*(1-focus)-mTravel*8)*innerHeight/100) + 'px,0) scale(1.04)');
    setStyle(mCopy,'opacity',String(mText));
    setStyle(mCopy,'transform','translate3d(0,' + ((8*(1-mText)-mTravel*24)*innerHeight/100) + 'px,0)');
    setStyle(mCopy,'filter','blur('+((1-mText)*7)+'px)');
    setStyle(mFront,'opacity','1');
    setStyle(mFront,'transform','translate3d(0,' + ((14*(1-mDetail)-mTravel*16)*innerHeight/100) + 'px,0) rotate(-5deg) scale(1.04)');
    setStyle(mFront,'filter','blur('+((1-mDetail)*10)+'px)');
    const mFringe=(1-focus)*1.4+close*1.8;
    if(full&&!lite){mRed.setAttribute('dx',String(mFringe));mBlue.setAttribute('dx',String(-mFringe))}
    if (!flowingClose) {
      setStyle(stay,'transform','translate3d(0,' + (135*(1-close)) + '%,0)');
      setStyle(stayInner,'transform','translate3d(0,' + (24*(1-settle)) + 'px,0)');
      setStyle(stayInner,'opacity',String(settle));
    } else {
      // Match the original pinned 135vh curved reveal, then hand the same DOM
      // back to normal flow at p=1. offsetTop excludes its visual transform.
      setProperty(stay,'--closing-overlap', ((readSize(act).height-innerHeight)*.035)+'px');
      const nativeTop = readRect(root).top + readSize(stay).top;
      const endTop=Math.max(0,innerHeight-readSize(stay).height);
      const endProgress=.965-endTop/Math.max(1,readSize(act).height-innerHeight);
      const footerClose=ease(.79,endProgress,raw);
      const revealTop=innerHeight*1.35*(1-footerClose)+endTop*footerClose;
      const offset = raw >= endProgress ? 0 : raw < .79 ? Math.max(0, revealTop-nativeTop) : revealTop-nativeTop;
      setProperty(stay,'--closing-offset', offset.toFixed(3)+'px');
      vault.toggleAttribute('data-occluded',outside || nativeTop+offset<=-2);
    }
    if (header) {
      setStyle(header,'opacity',String(1-enter*.45+settle*.45));
      setStyle(header,'color',settle>.6 ? '#211b17' : '#f4f0e8');
    }
    const intensity=window.MenasaQuality?.intensity ?? 1;
    if(lite){for(const node of [film,title,falcon,mosaic,fPhoto,mPhoto,fCopy,mCopy,fFront,mFront])setStyle(node,'filter','none');setStyle(title,'textShadow','none')}
    else if(intensity<1)for(const node of [film,title,falcon,mosaic,fPhoto,mPhoto,fCopy,mCopy,fFront,mFront])setStyle(node,'filter',node.style.filter.replace(/blur\(([\d.]+)px\)/g,(_,n)=>'blur('+(Number(n)*intensity).toFixed(2)+'px)'));
    setStyle(toggle,'visibility',p>.22 ? 'hidden' : 'visible');
    if (!flowingClose) stay.inert = close < .98;
    syncPlayback();
    root.dispatchEvent(new CustomEvent('menasa:journey'));
  }
  on(toggle,'click',()=>{
    userPaused=!video.paused;
    userPlayed=true;
    syncPlayback();
  });
  function syncToggle() {
    // SVG, not the ▶ character: iOS draws that one as a blue emoji.
    toggle.innerHTML = video.paused
      ? '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false"><path d="M3.5 2v8l6.5-4z" fill="currentColor"/></svg>'
      : '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false"><path d="M3 2h2v8H3zM7 2h2v8H7z" fill="currentColor"/></svg>';
    toggle.setAttribute('aria-label', video.paused ? 'Play film' : 'Pause film');
  }
  on(video,'play', syncToggle);
  on(video,'pause', syncToggle);

  function motionChange(){
    lastReduced=reduce.matches;
    video.playbackRate=1;
    scheduleFilm();
    last=-1;
    snap=true;
    userPlayed=false;
    stay.inert = !flowingClose && !reduce.matches;
    if (reduce.matches) setStyle(toggle,'visibility','visible');
    if(reduce.matches)for(const node of [film,vault,falcon,mosaic]){setStyle(node,'visibility','visible');node.removeAttribute('data-occluded')}
    if (flowingClose && reduce.matches) setProperty(stay,'--closing-offset','0px');
    syncPlayback();
    syncToggle();
  }
  reduce.addEventListener('change',motionChange);
  // Restores (Back, editor, page transitions) land on the exact frame, without a glide.
  sceneRenderers.push(()=>{cancelAnimationFrame(frameId);frameId=0;last=-1;snap=true;render()});
  motionChange();
  scheduleFilm();
  addEventListener('pagehide',()=>cancelAnimationFrame(frameId),{once:true});
})();



(() => {
  const root = document.querySelector('#study');
  const act = root.querySelector('.journey');
  const drop = document.querySelector('.drop');
  const header = document.querySelector('.site-header');
  const stay = root.querySelector('.closing');
  const filmEdge = document.querySelector('.drop__film-edge');
  const closingEdge = root.querySelector('.closing-curve');
  const patterns = [...document.querySelectorAll('[data-pattern]')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = value => Math.max(0, Math.min(1, value));
  const smooth = value => { const t = clamp(value); return t * t * (3 - 2 * t); };
  const mix = (from, to, progress) => from.map((value, i) => (value + (to[i] - value) * progress).toFixed(2)).join(' ');
  let frame = 0, previousTime = 0, dirty = true;
  let dark = 0, solid = 0, glass = 0, targetDark = 0, targetSolid = 0, targetGlass = 0, primed = false;
  function measure() {
    const h = innerHeight, band = h * .24, headerEdge = readSize(header).height;
    const filmRect = readRect(filmEdge), closeRect = readRect(closingEdge);
    // Center of each curved boundary; a 24vh band covers its varying slopes.
    const filmBoundary = filmRect.top + filmRect.height * .55;
    const closingBoundary = closeRect.top + closeRect.height * .46;
    targetDark = smooth((headerEdge + band / 2 - filmBoundary) / band) *
      (1 - smooth((headerEdge + band / 2 - closingBoundary) / band));
    targetSolid = smooth((h * .9 - readRect(drop).top) / (h * .9));
    // Leave the film visible through the existing 11px-to-zero blur slices.
    // Follow the same .08–.30 cover interval as the original Vault entrance.
    const progress = act.menasaProgress || 0;
    targetGlass = targetDark * (reduce.matches ? 1 : 1 - smooth((progress - .08) / .22));
    if (reduce.matches) {
      const filmBottom = root.querySelector('.film-panel').getBoundingClientRect().bottom;
      targetGlass *= smooth((filmBottom - headerEdge) / band);
    }
    setProperty(root,'--film-entry', smooth((h - readRect(root).top) / h).toFixed(4));
    setProperty(stay,'--closing-reveal', reduce.matches ? 1 : smooth((h * .88 - readRect(stay).top) / (h * .3)).toFixed(4));
    for (const plane of patterns) {
      if(plane.closest('[data-occluded]'))continue;
      const field = plane.parentElement, rect = readRect(field);
      // 10vh overscan exceeds the 8vh cap. Only update visible fields.
      if (rect.bottom < -h * .1 || rect.top > h * 1.1) continue;
      let y = 0;
      if (!reduce.matches && window.MenasaQuality?.tier!=='light' && field.classList.contains('pattern-field--film')) {
        // Reverse drift across the whole visible film, including the Vault
        // cover (.08–.30). Use scroll distance, never the pinned field's rect.
        const distance = h - readRect(act).top;
        const visibleTravel = h + (readSize(act).height - h) * .30;
        y = h * .08 * (1 - 2 * clamp(distance / visibleTravel));
      } else if (!reduce.matches && window.MenasaQuality?.tier!=='light') {
        const travel = h / 2 - (rect.top + rect.height / 2);
        y = Math.max(-h * .08, Math.min(h * .08, travel * .15));
      }
      setProperty(plane,'--pattern-y', y.toFixed(2) + 'px');
    }
    dirty = false;
  }
  function update(time) {
    frame = 0;
    if (dirty) measure();
    const dt = previousTime ? Math.min(64, time - previousTime) : 16.67;
    previousTime = time;
    const blend = reduce.matches ? 1 : 1 - Math.exp(-dt / 140);
    const follow = (current, target) => Math.abs(target - current) < .0001 ? target : current + (target - current) * blend;
    // Start at the navbar look for the current scroll position (a reload or Back to a
    // scrolled page) instead of easing in from the transparent top-of-page state.
    if (!primed) { dark = targetDark; solid = targetSolid; glass = targetGlass; primed = true; }
    dark = follow(dark, targetDark); solid = follow(solid, targetSolid); glass = follow(glass, targetGlass);
    setProperty(header,'--journey-dark', dark.toFixed(5));
    setProperty(header,'--nav-rgb', mix([250,247,239], [20,17,14], dark));
    setProperty(header,'--nav-ink', mix([24,27,28], [244,240,232], dark));
    // Only the glass tint reads these. Set on the header they restyled its whole subtree each
    // frame. Looked up every time: the theme rebuilds the glass when the effects tier changes.
    const tint = header.querySelector('.site-header__glass') || header;
    setProperty(tint,'--header-top', ((.5 + solid * .5) * (1 - glass * .18)).toFixed(3));
    setProperty(tint,'--header-bottom', (solid ** 4 * (1 - glass)).toFixed(3));
    if (dark !== targetDark || solid !== targetSolid || glass !== targetGlass) frame = requestAnimationFrame(update);
    else previousTime = 0;
  }
  function schedule() { dirty = true; if (!frame) frame = requestAnimationFrame(update); }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('hashchange', schedule);
  on(root,'menasa:journey', schedule);
  addEventListener('pageshow', schedule);
  document.addEventListener('menasa:quality', schedule);
  reduce.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(document.querySelector('main'));
  document.fonts.ready.then(schedule);

  sceneRenderers.push(time=>{cancelAnimationFrame(frame);dirty=true;update(time)});
  schedule();
})();

      on(window.document,'shopify:section:load',event=>{
        if(event.target.querySelector('#PrestigeHeader')){this.cleanup();this.connectedCallback()}
      });
      on(window.document,'shopify:block:select',event=>{
        const block=host.querySelector(`[data-shopify-editor-block*='"id":"${event.detail.blockId}"']`);
        block?.scrollIntoView({behavior:'instant',block:'center'});
      });
    }
    disconnectedCallback(){this.cleanup?.()}
  }
  customElements.define('menasa-artistic-scroll',ArtisticScroll);
})();
